import { Model } from './model';
import { QuotaItem } from './quota-item';
import { Ship } from './ship';

export class QuotaShip extends Model {
  public quota: QuotaItem = new QuotaItem();
  public ship: Ship = new Ship();
  public consumed: number;

  public static apiMap(values: Object = {}) {
    const quotaship = new QuotaShip(values);

    if (values['quota']) {
      quotaship.quota = new QuotaItem(values['quota']);
    }

    if (values['ship']) {
      quotaship.ship = new Ship(values['ship']);
    }

    return quotaship;
  }

  constructor(values: Object = {}) {
    super(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/quotaship.ts